import { Switch, Typography } from "@material-ui/core";
import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import { Animated } from "react-animated-css";
import {
  Accordion,
  AccordionCollapse,
  AccordionToggle,
  Button,
  Dropdown,
  DropdownButton
} from "react-bootstrap";
import CheckPermission from "../../General/CheckPermission";
import RBAC, { ModulesName, UserActions } from "../../General/roleModuleActions";
import { showDecisionAlert, showWarningAlert } from "../../../index";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader
} from "../../../_metronic/_partials/controls/Card";
import * as Api from "../../General/api";
import * as Common from "../../General/common";
import ResidentWounds from "../resident/residentWounds";
import PopupModal from "../modal/popupmodal";
import Newresident from "../modal/residentsmodals/newresident";
import Insurance from "../resident/insurance";
import ResidentDetails from "../resident/residentdetails";
import ResidentStatus from "../resident/residentStatus";
import ICDReport from "../modal/reports/icdreport";
import AOB from "../resident/aob";
import PatientOrders from "../resident/patientorders";
import ResidentNotes from "../resident/residentnotes";
import WoundLocation from "../resident/woundlocation";
import WoundNote from "../resident/woundnote";
import moment from "moment";
import SelectableContext from "react-bootstrap/SelectableContext";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FacilityResidentHistory from "../resident/residentHistory";
import SkipWoundMsg from "../resident/skipWoundMsg";
import NewWound from "../resident/newwound";
import { useSelector } from "react-redux";
import RecapEmail from "../recapEmail/recapEmail";

var UpsertNewresident,
  insuranceModal,
  residentHistoryModal,
  residentStatusModal,
  addStatusRef,
  residentInfoModal,
  AddResidentModal,
  patientOrdersModal,
  ResidentNotesModal,
  showSkipWoundMsgModal,
  WoundNoteModal,
  editWoundmodal = null;

var _sampleWoundObj = {
  fkResidentId: 0,
  residentName: "",
  facilityName: "",
  roomUnit: "",
  physicanName: "",
  btPatientBrightreeID: null,
  fkLastWoundDetailId: null,
  isWoundInfoChange: false,
  changeReason: "",
  fkSalesOrderId: 0,
  wound: {
    id: 0,
    woundDetailId: 0,
    fkWoundLocationId: null,
    woundLocation: "",
    fkWoundTypeId: null,
    woundDescription: "",
    fkWoundThicknessId: null,
    fkWoundLateralityId: null,
    woundLength: "",
    woundWidth: "",
    woundDepth: "",
    isUtd: false,
    tunneling: false,
    tunnelingDepth: null,
    tunnelingClockPosition: "",
    undermining: false,
    underminingDepth: null,
    underminingClockPosition: null,
    toUnderminingClockPosition: null,
    icdcode: "",
    fkExudateAmountId: null,
    fkExudateTypeId: null,
    exudateColor: "",
    fkDebridementTypeId: null,
    debridementDate: null,
    surgicalDate: null,
    odor: false,
    Pain: false,
    painMedicationOrdered: false,
    sloughPercentage: null,
    necroticPercentage: null,
    cleanseDescription: null,
    fkDressingChangeFrequencyId: 8,
    otherAdditionalPrimaryDressing: "",
    otherAdditionalSecondaryDressing: "",
    treatment: "",
    comments: "",
    thicknessIdForBackStagging: null,
    orientationLeftRight: null,
    orientationUpperLower: null,
    orientationInnerOuter: null,
    orientationAnteriorPosterior: null,
    orientationMedialLateral: null,
    orientationDorsalDistalProximal: null,
    orientationMidline: null,
    isDocumentation: false,
    isPartailOrder: false
  }
};

export function AllFacilityResident(props) {
  // region Resident modal
  const [showModalResident, setShowResident] = useState(false);
  const [isResidentInfoEdit, setisResidentInfoEdit] = useState(false);
  const [residentListUI, setResidentListUI] = useState([]);
  const [residentNameList, setResidentNameList] = useState([]); // drives Recap Email button
  const [Resident, setResident] = useState("");
  const [ResidentID, setResidentID] = useState("");
  const [ResidentName, setResidentName] = useState("");
  const FacilityId = props.facility.id;
  const [facilityName, setFacilityName] = useState("");
  const [chain, setChainName] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const { user } = useSelector((state) => state.auth);
  const handleCloseResident = () => setShowResident(false);
  const handleShowResident = () => setShowResident(true);
  // endregion

  const [addWoundComponent, setAddWoundComponent] = useState(null);
  const [showRecapEmail, setShowRecapEmail] = useState(false);
  const [residentLoading, setResidentLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // NEW: accordion control (all closed by default)
  const [activeAccordionKey, setActiveAccordionKey] = useState(null);

  useEffect(() => {
    getAllResident();
  }, []); // mount once

  // Fetch residents then build UI + wound-name list
  const getAllResident = useCallback(() => {
    setIsLoading(true);
    const finish = () => {
      setIsLoading(false);
      Common.LoadDataTable("residentsList");
    };

    if (props.isPartail) {
      Api.getRequestQry(
        Api.URI_GetAllBillingQueueResidentByFacilityID,
        "?facilityID=" +
          FacilityId +
          "&isPartailOrder=1&partailOrderDate=" +
          props.facility.cycleDate +
          "&processStatusId=" +
          props.facility.fkProcessStatusId
      )
        .then((res) => {
          if (
            res?.data?.statusCode == 200 &&
            Array.isArray(res.data.result) &&
            res.data.result.length > 0
          ) {
            buildResidentUIAndNames(res.data.result);
          } else {
            setResidentListUI([]);
            setResidentNameList([]);
          }
        })
        .catch(() => {
          setResidentListUI([]);
          setResidentNameList([]);
        })
        .then(finish);
    } else {
      Api.getRequestQry(
        Api.URI_GetAllResidentByFacilityID,
        "?facilityID=" + FacilityId
      )
        .then((res) => {
          if (
            res?.data?.statusCode == 200 &&
            Array.isArray(res.data.result) &&
            res.data.result.length > 0
          ) {
            buildResidentUIAndNames(res.data.result);
          } else {
            setResidentListUI([]);
            setResidentNameList([]);
          }
        })
        .catch(() => {
          setResidentListUI([]);
          setResidentNameList([]);
        })
        .then(finish);
    }
  }, [
    FacilityId,
    props.isPartail,
    props.facility?.cycleDate,
    props.facility?.fkProcessStatusId
  ]);

    const fixImageUrl = (newURL, fileName) => {

        var res = Resident;
        res.imageUrl = newURL;
        res.faceSheetName = fileName;
        setResident(res);

    }

  // ---- Batched parallel fetch for resident wounds ----
  const BATCH_SIZE = 10; // currently not batching, but left here if you expand later

  const fetchWoundsInBatches = async (residents) => {
    const names = [];
    console.time("wound-batches");
    for (let i = 0; i < residents.length; i++) {
      var res = residents[i];
      var isResidentOpen =
        res.residentStatus && res.residentStatus === "Open";
      if (isResidentOpen) {
        names.push(`${res.firstName} ${res.lastName}`);
      }
    }
    return names;
  };

  // Build UI rows and populate residentNameList (for Recap Email enable)
  const buildResidentUIAndNames = async (list) => {
    // 1) Fire batched wound checks
    try {
      const names = await fetchWoundsInBatches(list);
      setResidentNameList(names);
    } catch (e) {
      console.error("[WOUNDS] Batch error:", e);
      setResidentNameList([]);
    }

    // 2) Build UI rows (using a single Accordion above)
    const rows = list.map((obj) => {
      const eventKey = obj.id.toString();
      const name = `${obj.lastName}, ${obj.firstName}`;
      const dob = obj.doB ? moment(obj.doB).format("MM/DD/YYYY") : "N/A";

      let insurance = "No insurance on file";
      if (
        Array.isArray(obj.residentInsuranceList) &&
        obj.residentInsuranceList.length
      ) {
        insurance = obj.residentInsuranceList
          .map(
            (ins) =>
              `${ins.isAddEdit ? "*" : ""}=> ${ins.insuranceName}`
          )
          .join(", ");
      }

      return (
        <Card key={obj.id}>
          <CardHeader className="p-0">
            <AccordionToggle
              as="div"
              eventKey={eventKey}
              className="w-100"
              style={{ cursor: "pointer" }}
            >
              <div
                className={`w-100 d-flex border-bottom m-0 ${
                  obj.isProcess
                    ? "bg-light-success border-success"
                    : "border-light-dark"
                }`}
              >
                <div
                  className="customStyleAccorion"
                  style={{ display: "grid" }}
                >
                  <div
                    title={
                      obj.fkPrimaryPhysicianId == null
                        ? "Primary physician is not assigned"
                        : ""
                    }
                    className={`h5 mb-0 text-dark ${
                      obj.fkPrimaryPhysicianId == null
                        ? "bg-light-danger border-danger"
                        : ""
                    }`}
                  >
                    {name}
                  </div>

                  {obj.fkPrimaryPhysicianId == null && (
                    <small>Primary physician is not assigned<br /></small>
                  )}
                  <small>{insurance}</small>
                </div>

                <span className="badge my-auto mx-4 ml-auto">
                  <span
                    onClick={(e) => e.stopPropagation()} // prevent accordion toggle from dropdown clicks
                  >
                    <SelectableContext.Provider value={false}>
                      <DropdownButton
                        className="d-inline"
                        drop={"down"}
                        size="xs"
                        variant="primary"
                        title={"Actions"}
                        id={`dropdown-button-drop-actions-${obj.id}`}
                        key={"down"}
                      >
                        <Dropdown.Item
                          eventKey="1"
                          onClick={() => {
                            setResident(obj);
                            setisResidentInfoEdit(false);
                            setResidentID(obj.id);
                            residentInfoModal.showModal();
                          }}
                        >
                          Resident Info
                        </Dropdown.Item>
                        <Dropdown.Item
                          eventKey="8"
                          onClick={() => handleResidentStatus(obj)}
                        >
                          Set Resident Status
                        </Dropdown.Item>
                        <Dropdown.Item
                          eventKey="81"
                          onClick={() => handleResidentHistory(obj.id)}
                        >
                          View History
                        </Dropdown.Item>
                        <Dropdown.Item
                          eventKey="8"
                          onClick={() => {
                            setResidentID(obj.id);
                            setResidentName(
                              `${obj.firstName} ${obj.lastName}`
                            );
                            setFacilityName(props.facility.facilityName);
                            setChainName(props.facility.chain);
                            setOrganizationName(
                              props.facility.organizationName
                            );
                            ResidentNotesModal.showModal();
                          }}
                        >
                          Resident Notes
                        </Dropdown.Item>
                        <Dropdown.Item
                          eventKey="2"
                          onClick={() => {
                            setResidentID(obj.id);
                            showSkipWoundMsgModal.showModal();
                          }}
                        >
                          View Skip Wound Messages
                        </Dropdown.Item>
                      </DropdownButton>
                    </SelectableContext.Provider>
                  </span>
                </span>
              </div>
            </AccordionToggle>
          </CardHeader>

          <AccordionCollapse
            eventKey={eventKey}
            mountOnEnter
            unmountOnExit
          >
            <CardBody>
              <fieldset>
                <ResidentWounds
                  isPartail={props.isPartail}
                  facility={props.facility}
                  refresh={() => {
                    getAllResident();
                  }}
                  Resident={obj}
                />
              </fieldset>
            </CardBody>
          </AccordionCollapse>
        </Card>
      );
    });

    setResidentListUI(rows);
  };

  const handleShowAddResident = (obj) => {
    setResident(obj);
    AddResidentModal.showModal();
  };

  const handleResidentStatus = async (resident) => {
    setResident(resident);
    residentStatusModal.showModal();
  };

  const handleResidentHistory = async (residentId) => {
    setResidentID(residentId);
    residentHistoryModal.showModal();
  };

  const handleNewWound = (newWoundDetail) => {
    setResident(newWoundDetail);
    Common.showConfirmation(
      "Would you like to enter a wound.",
      "",
      handleNewWoundModal,
      null,
      newWoundDetail,
      "Yes",
      false,
      null,
      "No"
    );
  };

  const handleNewWoundModal = (obj) => {
    let residenObj = JSON.parse(JSON.stringify(_sampleWoundObj));
    residenObj.fkResidentId = obj.id;
    residenObj.residentName =
      Common.replaceNullWithString(obj.firstName) +
      " " +
      Common.replaceNullWithString(obj.lastName);
    residenObj.facilityName = Common.replaceNullWithString(
      props.facility.facilityName
    );
    residenObj.roomUnit =
      Common.replaceNullWithString(obj.room) +
      "/" +
      Common.replaceNullWithString(obj.unit);
    residenObj.physicanName = Common.replaceNullWithString(
      obj.primaryPhysicianName
    );
    residenObj.btPatientBrightreeID = obj.btPatientBrightreeID;

    if (obj.fkResidentStatusId == Common.ResidentStatusID.open) {
      setAddWoundComponent(
        <NewWound
          refresh={() => getAllResident()}
          isEdit={false}
          isReorder={false}
          showProduct={false}
          isReadOnly={false}
          user={user}
          displayProduct={true}
          queue={props.queue || Common.ProcessStatus.workQueueID}
          resident={residenObj}
          close={() => handleCloseWoundmodalPopup()}
        />
      );
      editWoundmodal.showModal();
    } else {
      Common.showSuccessAlert(
        "Resident is not open please update resident status to add/update new wound",
        "warning",
        "Warning!",
        3000
      );
    }
  };

  const handleCloseWoundmodalPopup = () => {
    editWoundmodal.hideModal();
    getAllResident();
  };

  const [ShowAdvancedSearch, showAdvanceSearchSectionState] =
    useState(false);
  const showAdvanceSearchSection = () => {
    showAdvanceSearchSectionState(!ShowAdvancedSearch);
  };

  const toolbar = (
    <div className="card-toolbar">
      <div className="example-tools">
        {user.roles.roleList.find(
          (x) => x.roleName == RBAC.Role_Gentell_IntakeProcessor
        ) == undefined && (
          <CheckPermission
            permission={UserActions.Create}
            module={ModulesName.Module_Residents}
            yes={() => (
              <Button
                variant="primary"
                size="sm"
                className="mr-5"
                onClick={() => {
                  handleShowAddResident(null);
                }}
              >
                New Resident
              </Button>
            )}
            no={() => (
              <Button
                variant="primary"
                size="sm"
                className="mr-5"
                disabled={true}
              >
                New Resident
              </Button>
            )}
          />
        )}

        {/* Recap Email is DISABLED until residentNameList has entries */}
        <button
          type="button"
          className="mr-5 btn btn-primary btn-sm"
          disabled={residentNameList.length === 0}
          onClick={() => setShowRecapEmail(true)}
        >
          Recap Email
        </button>

        <button
          type="button"
          className="mr-5 btn btn-dark btn-sm"
          onClick={() => props.backPress()}
        >
          Back To Facility List
        </button>
      </div>
    </div>
  );

  return (
    <>
      {showRecapEmail && (
        <Animated
          animationIn="fadeIn"
          animationInDuration={1000}
          animationOut="fadeOut"
          isVisible={showRecapEmail}
        >
          <RecapEmail
            backPress={() => setShowRecapEmail(false)}
            facility={props.facility}
            residentList={residentNameList}
          />
        </Animated>
      )}

      {!showRecapEmail && (
        <Card className="example example-compact">
          <CardHeader>
            <div className="card-title">
              <span>
                <b className="text-success">
                  Facility: {props.facility.facilityName}
                </b>{" "}
                ,{" "}
                <br />
                <b>Ownership/Headquarters:</b>{" "}
                {props.facility.organizationName == ""
                  ? "N/A"
                  : props.facility.organizationName}
                ,{" "}
                <b>Purchasing Group-Chain:</b>{" "}
                {props.facility.chain == "" ? "N/A" : props.facility.chain}
                ,{" "}
                <b>
                  <FormControlLabel
                    label={
                      <Typography>
                        <h4 className="mt-4"> Part B:</h4>
                      </Typography>
                    }
                    labelPlacement="start"
                    control={
                      <Checkbox
                        checked={props.facility.medicarePartBbyGentell}
                        value="checkedA"
                      />
                    }
                  />
                  <FormControlLabel
                    label={
                      <Typography>
                        <h4 className="mt-4"> Equal Care:</h4>
                      </Typography>
                    }
                    labelPlacement="start"
                    control={
                      <Checkbox
                        checked={props.facility.isEcp}
                        value="checkedB"
                      />
                    }
                  />
                  <FormControlLabel
                    label={
                      <Typography>
                        <h4 className="mt-4">Outs:</h4>
                      </Typography>
                    }
                    labelPlacement="start"
                    control={
                      <Checkbox
                        checked={props.facility.outProgram}
                        value="checkedC"
                      />
                    }
                  />
                </b>
                <h3 className="card-label mt-3">Resident List</h3>
              </span>
            </div>
            {toolbar}
          </CardHeader>
          <CardBody>
            {isLoading ? (
              <div className="row d-flex justify-content-center">
                <span className="mt-5 spinner spinner-primary"></span>
              </div>
            ) : (
              <Accordion
                activeKey={activeAccordionKey ?? undefined}
                onSelect={(key) =>
                  setActiveAccordionKey((prev) =>
                    prev === key ? null : key
                  )
                }
              >
                {residentListUI}
              </Accordion>
            )}
          </CardBody>
        </Card>
      )}

      <PopupModal
        title="Insurances"
        showButton={false}
        ref={(ref) => {
          insuranceModal = ref;
        }}
      >
        <Insurance residentID={ResidentID} />
      </PopupModal>

      <PopupModal
        title="Resident Info"
        showButton={false}
        dialogClassName="modal-90w"
        ref={(ref) => {
          residentInfoModal = ref;
        }}
      >
        {isResidentInfoEdit && (
          <Animated
            animationIn="fadeIn"
            animationInDuration={800}
            animationOut="fadeOut"
            onClose={(ref) => {
              Common.showConfirmation(
                "Are you sure you want to close without saving the data?",
                "Warning",
                () => {
                  ref.setState({ show: false });
                },
                () => {},
                null,
                "Exit Without Saving"
              );
            }}
          >
            <div className="row d-flex align-items-center justify-content-end">
              <Button
                className="mb-4 mr-4 "
                onClick={() => {
                  setisResidentInfoEdit(!isResidentInfoEdit);
                }}
              >
                Go Back To Detail
              </Button>
            </div>
            <Newresident
              ref={(ref) => {
                UpsertNewresident = ref;
              }}
              FacilityId={FacilityId}
              Resident={Resident}
              facility={props.facility}
              setResidentLoading={setResidentLoading}
              handleNewWound={handleNewWound}
              close={() => {
                getAllResident(false);
                setResidentLoading(false);
                residentInfoModal.hideModal(true);
              }}
            />
            <div className="row d-flex align-items-center justify-content-end">
              <Button
                className="mb-4 btn-success ml-2"
                disabled={residentLoading}
                onClick={() => {
                  UpsertNewresident.handleSubmit();
                }}
              >
                <span
                  style={{ display: "flex", alignItems: "center" }}
                >
                  {residentLoading && (
                    <span className="mr-8 spinner spinner-white"></span>
                  )}
                  <span>Save Changes</span>
                </span>
              </Button>
            </div>
          </Animated>
        )}

        {!isResidentInfoEdit && (
          <Animated
            animationIn="fadeIn"
            animationInDuration={800}
            animationOut="fadeOut"
          >
            <div className="row d-flex align-items-center justify-content-end">
              <Button
                className="mb-4 mr-4"
                onClick={() => {
                  setisResidentInfoEdit(!isResidentInfoEdit);
                }}
              >
                Edit
              </Button>
            </div>
            <ResidentDetails
                          resident={Resident}
                          getAllResident={() => {
                              getAllResident(false);
                          }}
                          fixImageUrl={fixImageUrl}
            />
          </Animated>
        )}
      </PopupModal>

      <PopupModal
        title="Resident Orders"
        dialogClassName="modal-90w"
        showButton={false}
        ref={(ref) => {
          patientOrdersModal = ref;
        }}
      >
        <PatientOrders />
      </PopupModal>

      <PopupModal
        title="Add Wound Note"
        size="lg"
        showButton={true}
        ref={(ref) => {
          WoundNoteModal = ref;
        }}
      >
        <WoundNote />
      </PopupModal>

      <PopupModal
        title={
          <div className="card-title">
            <span>
              <h3 className="card-label">Resident Notes</h3>
              <small className="">
                <b>Resident:</b> {ResidentName},{" "}
                <b>Facility:</b> {facilityName},{" "}
                <b>Chain:</b> {chain},{" "}
                <b>Group:</b> {organizationName},{" "}
              </small>
            </span>
          </div>
        }
        dialogClassName="modal-90w"
        showButton={false}
        ref={(ref) => {
          ResidentNotesModal = ref;
        }}
      >
        <ResidentNotes FacilityId={FacilityId} ResidentID={ResidentID} />
      </PopupModal>

      <PopupModal
        title={
          <div className="card-title">
            <span>
              <h3 className="card-label">Add Resident</h3>
              <small className="">
                <b>Facility:</b> {props.facility.facilityName},{" "}
                <b>Ownership/Headquarters:</b>{" "}
                {props.facility.organizationName == ""
                  ? "N/A"
                  : props.facility.organizationName}
                , <b>Operators/Purchasing Group:</b>{" "}
                {props.facility.chain == "" ? "N/A" : props.facility.chain}
                ,
              </small>
            </span>
          </div>
        }
        dialogClassName="modal-97w"
        showButton={true}
        ref={(ref) => {
          AddResidentModal = ref;
        }}
        buttonDisabled={residentLoading}
        buttonPress={() => UpsertNewresident.handleSubmit()}
        module={ModulesName.Module_Residents}
        action={UserActions.Create}
        onClose={(ref) => {
          Common.showConfirmation(
            "Are you sure you want to close without saving the data?",
            "Warning",
            () => {
              ref.setState({ show: false });
            },
            () => {},
            null,
            "Exit Without Saving"
          );
        }}
      >
        <Newresident
          ref={(ref) => {
            UpsertNewresident = ref;
          }}
          user={user}
          handleNewWound={handleNewWound}
          FacilityId={FacilityId}
          Resident={Resident}
          facility={props.facility}
          setResidentLoading={setResidentLoading}
          close={() => {
            getAllResident();
            AddResidentModal.hideModal(true);
            setResidentLoading(false);
          }}
        />
      </PopupModal>

      <PopupModal
        title={
          <div className="card-title">
            <span>
              <h3 className="card-label">Resident Status</h3>
              <small className="">
                <b>Facility:</b> {props.facility.facilityName},{" "}
                <b>Ownership/Headquarters:</b>{" "}
                {props.facility.organizationName == ""
                  ? "N/A"
                  : props.facility.organizationName}
                , <b>Purchasing Group-Chain:</b>{" "}
                {props.facility.chain == "" ? "N/A" : props.facility.chain}
                ,
              </small>
            </span>
          </div>
        }
        ref={(ref) => {
          residentStatusModal = ref;
        }}
        showButton={true}
        buttonPress={() => addStatusRef.onSubmit()}
        module={ModulesName.Module_Residents}
        action={UserActions.Update}
      >
        <ResidentStatus
          ref={(ref) => {
            addStatusRef = ref;
          }}
          resident={Resident}
          close={() => {
            getAllResident();
            residentStatusModal.hideModal();
          }}
        />
      </PopupModal>

      <PopupModal
        title={
          <div className="card-title">
            <span>
              <h3 className="card-label">Resident History</h3>
              <small className="">
                <b>Facility:</b> {props.facility.facilityName},{" "}
                <b>Ownership/Headquarters:</b>{" "}
                {props.facility.organizationName == ""
                  ? "N/A"
                  : props.facility.organizationName}
                , <b>Purchasing Group-Chain:</b>{" "}
                {props.facility.chain == "" ? "N/A" : props.facility.chain}
                ,
              </small>
            </span>
          </div>
        }
        showButton={false}
        ref={(ref) => {
          residentHistoryModal = ref;
        }}
      >
        <FacilityResidentHistory fkResidentId={ResidentID} />
      </PopupModal>

      <PopupModal
        title={
          <div className="card-title">
            <span>
              <h3 className="card-label">Skip Wounds Message</h3>
              <small className="">
                <b>Facility:</b> {props.facility.facilityName},{" "}
                <b>Ownership/Headquarters:</b>{" "}
                {props.facility.organizationName == ""
                  ? "N/A"
                  : props.facility.organizationName}
                , <b>Purchasing Group-Chain:</b>{" "}
                {props.facility.chain == "" ? "N/A" : props.facility.chain}
                ,
              </small>
            </span>
          </div>
        }
        showButton={false}
        ref={(ref) => {
          showSkipWoundMsgModal = ref;
        }}
      >
        <SkipWoundMsg
          fkResidentId={ResidentID}
          onSave={() => {
            showSkipWoundMsgModal.hideModal();
          }}
        />
      </PopupModal>

      <PopupModal
        onClose={(ref) => {
          getAllResident();
          ref.setState({ show: false });
        }}
        title={
          <div className="card-title">
            <span>
              <h3 className="card-label">Wound Evaluation</h3>
            </span>
          </div>
        }
        dialogClassName="modal-95w"
        ref={(ref) => {
          editWoundmodal = ref;
        }}
      >
        {addWoundComponent}
      </PopupModal>
    </>
  );
}

export default AllFacilityResident;
